import { SwipeableDrawer, SwipeableDrawerProps } from '@mui/material'

type ActionDrawerProps = Omit<SwipeableDrawerProps, 'anchor'>

export const ActionDrawerContainer = ({ open, children, ...restProps }: ActionDrawerProps) => {
    return (
        <SwipeableDrawer
            anchor="right"
            open={open}
            PaperProps={{ sx: { width: { xs: '100%', sm: '400px' } } }}
            {...restProps}
        >
            {open && children}
        </SwipeableDrawer>
    )
}
